import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'
import { useState } from 'react'
import MapStaticComponent from '../../../../../components/common/googleMaps/GoogleMapsStaticComponent'

const CheckShareholders = ({ shareholdersCheck, name }) => {
  const { t } = useTranslation(['common', 'messages'])
  const hasChecks = Array.isArray(shareholdersCheck) && shareholdersCheck?.length > 0
  const checkLength = shareholdersCheck?.length || 0
  const [coordinates, setCoordinates] = useState(null)

  const finalAddress = (element) => {
    const addresses = element?.addresses

    if (Array.isArray(addresses) && addresses.length) {
      const aux = addresses.find((addr) => addr.type === 'PRINCIPAL') || addresses[0]

      if (typeof aux === 'object') {
        return `${aux.street || '-'}, ${aux.number || '-'}, ${aux.city || '-'}, ${aux.state || '-'}, ${
          aux.postcode || '-'
        }, ${aux.country || '-'}`
      }

      return aux
    }

    return ''
  }

  const finalPhones = (element) => {
    if (Array.isArray(element?.phoneNumberList) && element.phoneNumberList.length) {
      const phoneItems = element.phoneNumberList
        .map((phone) => `${phone.AreaCode || phone.ddd || ''} ${phone.Number || phone.numero || ''}`.trim())
        .filter(Boolean)

      if (!phoneItems.length) return null

      return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', columnGap: '.5rem' }}>
          {phoneItems?.map((phone, index) => (
            <div key={index}>
              ✆ <Typography variant="subtitle3">{phone}</Typography>
            </div>
          ))}
        </div>
      )
    }
    return null
  }

  const finalEmails = (element) => {
    if (Array.isArray(element?.emailList) && element.emailList.length) {
      const emailItems = element.emailList.map((e) => e.EmailAddress || e.email || e).filter(Boolean)

      if (!emailItems.length) return null

      return (
        <ul className="check-details-list">
          {emailItems.map((email, index) => (
            <li key={index}>{email}</li>
          ))}
        </ul>
      )
    }
    return null
  }

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{name}</Typography>

        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      {!Array.isArray(shareholdersCheck) && shareholdersCheck?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{shareholdersCheck.informação ?? '---'}</Typography>
        </Paper>
      )}

      {hasChecks &&
        shareholdersCheck?.map((element, index) => {
          const relationships = Array.isArray(element.relationships)
            ? element.relationships.map((rel) => `${rel.type ?? '---'}${rel.name ? ` - ${rel.name}` : ''}`).join(', ')
            : element.relationship
            ? `${element.relationship.type ?? '---'} - ${element.relationship.name ?? '---'}`
            : '---'

          return (
            <Paper key={index} variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:name')}</Typography>
                  <Typography variant="subtitle3">{element.name ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:document')}</Typography>
                  <Typography variant="subtitle3">
                    {element.documentNumber?.includes('kyb.documentNumber.notFound') 
                      ? `⚠️${t('messages:kyb.documentNumber.notFound')}⚠️` 
                      : element.documentNumber ?? '---'
                    }
                  </Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:nationality')}</Typography>
                  <Typography variant="subtitle3">{element.nationality ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:type')}</Typography>
                  <Typography variant="subtitle3">{element.type ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:relationship')}</Typography>
                  <Typography variant="subtitle3">{relationships}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:gender')}:</Typography>
                  <Typography variant="subtitle3">{element?.gender ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:dateOfBirth')}:</Typography>
                  <Typography variant="subtitle3">{element?.dateOfBirth ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:email')}:</Typography>
                  {finalEmails(element) ?? <Typography variant="subtitle3">---</Typography>}
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:motherName')}:</Typography>
                  <Typography variant="subtitle3">{element?.motherName ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:rendaPresumida')}:</Typography>
                  <Typography variant="subtitle3">{element?.rendaPresumida ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:situacaoImpostoRenda')}:</Typography>
                  <Typography variant="subtitle3">
                    {element?.situacaoImpostoRenda ? element?.situacaoImpostoRenda : '---'}
                  </Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:cpfRegistrationDate')}:</Typography>
                  <Typography variant="subtitle3">{element?.cpfRegistrationDate ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:riskLevel')}</Typography>
                  <Typography variant="subtitle3">{t(`common:${element.riskLevel}`)}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:score')}</Typography>
                  <Typography variant="subtitle3">{element.riskScore ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:phones')}:</Typography>
                  {finalPhones(element) ?? <Typography variant="subtitle3">---</Typography>}
                </div>
                <div className="c-detail-col" style={{ gridColumn: '1 / 3' }}>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">{t('common:address')}:</Typography>
                    <Typography variant="subtitle3">{finalAddress(element) || '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <MapStaticComponent
                      fixedAddress={finalAddress(element)}
                      height={300}
                      width={450}
                      borderRadius={2}
                      onCoordinatesFetched={setCoordinates}
                    />
                    <MapStaticComponent
                      fixedAddress={finalAddress(element)}
                      height={300}
                      width={450}
                      borderRadius={2}
                      showStreetView
                    />
                  </div>
                </div>
              </div>
            </Paper>
          )
        })}
    </>
  )
}

export default CheckShareholders
